.phoneNumberInputs {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border-radius: 8px;
  justify-content: center;
  width: 100%;

  .selectContainer {
    min-width: 80px;
    max-width: 95px;
  }

  .textInputContainer {
    height: 50px;
    width: 100%;
    flex: 1;
    position: relative;
    overflow: hidden;

    .removeButton {
      position: absolute;
      display: none;
      right: 12px;
      top: 20px;
      z-index: 2;
    }
    
    &:hover .removeButton {
      display: block;
    }
    
    &.disableBackgroundColor .textInput {
      background-color: unset;
    }

    .textInput {
      padding-left: 12px;
      border-radius: 8px;
      position: relative;
      height: 100%;
      border: none;
      outline: none;
      -moz-appearance: textfield;
      box-sizing: border-box;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      @include themify($themes) {
        background-color: themed("neutral-tertiary");
        color: themed("main-primary");
        border-right: solid 1px themed("neutral-secondary");
        border-top: solid 1px themed("neutral-secondary");
        border-bottom: solid 1px themed("neutral-secondary");
      }
    }
  }
}
